import React, { useState } from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import CalendarViewMonthOutlinedIcon from "@mui/icons-material/CalendarViewMonthOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import AbsencesMonthTab from "./AbsencesMonthTab";
import VacationCalendarTab from "./VacationCalendarTab";

const CalendarTab = ({
  selectedUserId,
  canRrhh,
  canFichaje,
  employees = [],
}) => {
  const theme = useTheme();
  const accent = theme.palette.primary.main;
  const [view, setView] = useState("month");

  return (
    <Box sx={{ minWidth: 0 }}>
      <Box
        sx={{
          mb: 2,
          display: "flex",
          justifyContent: { xs: "stretch", sm: "flex-start" },
        }}
      >
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={(_, next) => {
            if (next) setView(next);
          }}
          size="small"
          sx={{
            width: { xs: "100%", sm: "auto" },
            p: 0.35,
            borderRadius: 2,
            bgcolor: alpha(theme.palette.background.paper, 0.7),
            border: "1px solid",
            borderColor: alpha(theme.palette.divider, 0.65),
            "& .MuiToggleButtonGroup-grouped": {
              border: 0,
              borderRadius: "6px !important",
              mx: 0.15,
              px: 2,
              py: 0.65,
              fontWeight: 700,
              fontSize: "0.8125rem",
              textTransform: "none",
              color: theme.palette.text.secondary,
              flex: { xs: 1, sm: "none" },
              "&.Mui-selected": {
                color: theme.palette.primary.dark,
                bgcolor: alpha(accent, 0.14),
                boxShadow: `0 2px 8px ${alpha(accent, 0.18)}`,
                "&:hover": {
                  bgcolor: alpha(accent, 0.18),
                },
              },
            },
          }}
        >
          <ToggleButton value="month">
            <CalendarViewMonthOutlinedIcon sx={{ fontSize: 18, mr: 0.75 }} />
            Mes
          </ToggleButton>
          <ToggleButton value="year">
            <DateRangeOutlinedIcon sx={{ fontSize: 18, mr: 0.75 }} />
            Año
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {view === "month" ? (
        <AbsencesMonthTab
          selectedUserId={selectedUserId}
          canRrhh={canRrhh}
          canFichaje={canFichaje}
          employees={employees}
        />
      ) : (
        <VacationCalendarTab canRrhh={canRrhh} />
      )}
    </Box>
  );
};

export default CalendarTab;
